import {
  configureStore,
  combineReducers,
  isRejectedWithValue,
  isPending,
  isFulfilled,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  Storage,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'

import userInputReducer from "./slices/userInputSlice"
import flightSearchReducer from "./slices/flightSearchSlice"
import flightFilterReducer from "./slices/filterSlice"
import userSlice from "./slices/userSlice"
import { bookingModuleApi } from './services/booking';
import flightDetailsReducer from './slices/flightDetails';

const reducers = combineReducers({
  // [api.reducerPath]: api.reducer,
  [bookingModuleApi.reducerPath]: bookingModuleApi.reducer,
  userInputs: userInputReducer,
  flightFilters: flightFilterReducer,
  flightSearch: flightSearchReducer,
  user: userSlice,
  flightDetails: flightDetailsReducer,
});


//   const storage = new MMKV();
//   export const reduxStorage = {
//     setItem: (key, value) => {
//       storage.set(key, value);
//       return Promise.resolve(true);
//     },
//     getItem: key => {
//       const value = storage.getString(key);
//       return Promise.resolve(value);
//     },
//     removeItem: key => {
//       storage.delete(key);
//       return Promise.resolve();
//     },
//   };

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['theme', 'auth', 'userInputs'],
  blacklist: ['UserApi'],
};

const persistedReducer = persistReducer(persistConfig, reducers);
//** For handingling failure cases acts like interceptor */ /
const rtkQueryHandler = (_api: unknown) => (next: (action: any) => any) => (action: any) => {
  if (isRejectedWithValue(action)) {
    if (action?.payload?.code == 'UNAUTHORIZED') {
      // setTimeout(() => store.dispatch(toggleUnauthorizedModal(true)), 500);
    }
  }
  return next(action);
};

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => {
    const middlewares = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      rtkQueryHandler,
      bookingModuleApi.middleware
    ]);
    return middlewares;
  },
});

const persistor = persistStore(store);

setupListeners(store.dispatch);

export { store, persistor };
